import { CircularProgress } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import DataGrid from "@poseidon/ui/components/DataGrid";
import { DataGridContainer } from "@poseidon/ui/components/DataGridContainer";
import { columns } from "./getColumnDefinition";
import { useBoats } from "../useBoats";

export default function ListBoats() {
  const { setError } = useErrorMessage();
  const { boats, loading, error } = useBoats();

  if (error) {
    setError(error);
  }

  if (loading || !boats) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }

  return (
    <DataGridContainer>
      <DataGrid
        useSessionStorageForPagination
        id="boats"
        columns={columns}
        rows={boats}
        doubleClickSlug="boats"
      />
    </DataGridContainer>
  );
}
